export enum WincoEvents
{
  SET_ASIDE = 'WINCO_EXERCISE_SET_ASIDE',
  SET_BUTTONS = 'WINCO_EXERCISE_SET_BUTTONS',
  SHOW_VIDEO_BUTTON = 'WINCO_EXERCISE_SHOW_VIDEO_BUTTON',
  ON_UPDATE_BETTER = 'WINCO_EXERCISE_ON_UPDATE_BETTER',
  SHOW_BEST_EXERCISE = 'WINCO_EXERCISE_SHOW_BEST_EXERCISE',
  HIDE_BEST_EXERCISE = 'WINCO_EXERCISE_HIDE_BEST_EXERCISE',
  CLOSE_EXERCISE = 'WINCO_EXERCISE_CLOSE_EXERCISE',
  START_EXERCISE = 'WINCO_EXERCISE_START_EXERCISE',
  TRACKING_CHECK = 'WINCO_EXERCISE_TRACKING_CHECK',
  GET_BETTER_SCORE = 'WINCO_EXERCISE_GET_BETTER_SCORE',

  GET_EXERCISE_BY_UUID = 'WINCO_LIST_GET_EXERCISE_BY_UUID',

  ENABLE_USER = 'WINCO_AUTH_ENABLE_USER',

  RESIZE_CAMERA = 'WINCO_CAMERA_RESIZE_CAMERA',
  CONNECT_AUXILIAR_CAMERA = 'WINCO_CAMERA_CONNECT_AUXILIAR_CAMERA',
  DISCONNECT_AUXILIAR_CAMERA = 'WINCO_CAMERA_DISCONNECT_AUXILIAR_CAMERA',
  CHANGE_CAMERA = 'WINCO_CAMERA_CHANGE_CAMERA',

  SAVE_FILE = 'WINCO_IPC_SAVE_FILE',
  EXPORT_ANALYSIS_PDF = 'WINCO_IPC_EXPORT_ANALYSIS_PDF',

  LANGUAGE_SOURCE = 'WINCO_LANGUAGE_LANGUAGE_SOURCE',

  STOP_VIDEO = 'WINCO_VIDEO_STOP_VIDEO',

  SHOW_STUDENT_PROGRESS = 'WINCO_HEADER_SHOW_STUDENT_PROGRESS',
  IA_ANALIZED = 'WINCO_VIDEO_IA_ANALIZED',
}
